/**
 * Collect device + optional GPS context for login audit logs.
 * Geolocation is best-effort and must never block login.
 */

function detectDeviceInfo() {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''

  let deviceType = 'desktop'
  if (/tablet|ipad/i.test(ua)) deviceType = 'tablet'
  else if (/mobile|iphone|android/i.test(ua)) deviceType = 'mobile'

  let browser = 'Unknown'
  if (/edg/i.test(ua)) browser = 'Edge'
  else if (/chrome|crios/i.test(ua)) browser = 'Chrome'
  else if (/firefox|fxios/i.test(ua)) browser = 'Firefox'
  else if (/safari/i.test(ua) && !/chrome|crios/i.test(ua)) browser = 'Safari'

  let os = 'Unknown'
  if (/windows/i.test(ua)) os = 'Windows'
  else if (/android/i.test(ua)) os = 'Android'
  else if (/iphone|ipad|ipod/i.test(ua)) os = 'iOS'
  else if (/mac os/i.test(ua)) os = 'macOS'
  else if (/linux/i.test(ua)) os = 'Linux'

  return { deviceType, browser, os }
}

function getCurrentPosition(timeoutMs = 4000) {
  return new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      resolve(null)
      return
    }

    const timer = setTimeout(() => resolve(null), timeoutMs)

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(timer)
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        })
      },
      () => {
        clearTimeout(timer)
        resolve(null)
      },
      {
        enableHighAccuracy: false,
        timeout: timeoutMs,
        maximumAge: 5 * 60 * 1000,
      }
    )
  })
}

/**
 * Returns payload fields to send with login (device + optional coords).
 */
export async function collectLoginContext() {
  const device = detectDeviceInfo()
  const coords = await getCurrentPosition(4000)

  return {
    ...device,
    ...(coords
      ? { latitude: coords.latitude, longitude: coords.longitude }
      : {}),
  }
}
